<template>
  <div style="padding: 20px">
    <el-card>
      <template #header>
        <div style="display:flex;justify-content:space-between;align-items:center">
          <span>师徒关系管理</span>
        </div>
      </template>
      <el-form :inline="true" @submit.prevent>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="全部" clearable style="width:120px">
            <el-option label="已结对" :value="1" />
            <el-option label="进行中" :value="2" />
            <el-option label="已完成" :value="3" />
            <el-option label="已解绑" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="导师姓名">
          <el-input v-model="query.keyword" placeholder="导师/徒弟姓名" clearable style="width:160px" />
        </el-form-item>
        <el-form-item label="期">
          <el-select v-model="query.period" placeholder="全部期" clearable style="width:120px">
            <el-option v-for="y in periodOptions" :key="y" :label="y + '期'" :value="y" />
          </el-select>
        </el-form-item>
        <el-form-item label="添加时间">
          <el-date-picker v-model="query.dateRange" type="daterange" range-separator="~"
            start-placeholder="开始" end-placeholder="结束" value-format="YYYY-MM-DD" style="width:240px" />
        </el-form-item>
        <el-form-item label="雷达">
          <el-select v-model="query.radar" placeholder="全部" clearable style="width:120px">
            <el-option label="有雷达" :value="1" />
            <el-option label="无雷达" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button type="success" @click="pairVisible = true">新建结对</el-button>
          <el-button type="warning" @click="importVisible = true">批量导入</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border v-loading="loading" style="width:100%">
        <el-table-column prop="relation.id" label="ID" width="80" />
        <el-table-column prop="mentorName" label="导师" />
        <el-table-column prop="apprenticeName" label="徒弟" />
        <el-table-column label="期 / 阶段" width="150">
          <template #default="{row}">{{ periodStageText(row) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template #default="{row}">
            <el-tag :type="statusTag(row.relation.status)">{{ statusText(row.relation.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="relation.pairPeriodStart" label="结对周期" width="180">
          <template #default="{row}">{{ row.relation.pairPeriodStart }} ~ {{ row.relation.pairPeriodEnd }}</template>
        </el-table-column>
        <el-table-column prop="relation.createTime" label="添加时间" width="170" />
        <el-table-column label="雷达" width="80">
          <template #default="{row}">
            <el-tag v-if="row.hasRadar" type="success" size="small">有</el-tag>
            <el-tag v-else type="info" size="small">无</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template #default="{row}">
            <el-button size="small" type="primary" @click="showProgress(row.relation.id)">进度</el-button>
            <el-button v-if="row.hasRadar" size="small" @click="goRadar(row)">雷达</el-button>
            <el-button v-else size="small" disabled>无雷达</el-button>
            <el-button size="small" type="danger" :disabled="row.relation.isDelete === 1" @click="doDelete(row.relation.id)">删除</el-button>
            <el-button size="small" type="warning" :disabled="row.relation.status===4" @click="doUnpair(row.relation.id)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top:12px"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="query.page"
        :page-size="query.size"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="onPage"
        @size-change="onSize" />
    </el-card>

    <!-- 新建结对（HR 代建，支持跨校区跨城市） -->
    <el-dialog v-model="pairVisible" title="新建结对" width="520px">
      <el-form label-width="90px">
        <el-form-item label="导师">
          <el-select v-model="pairForm.mentorId" filterable remote reserve-keyword :remote-method="searchMentor" :loading="coachLoading" placeholder="输入姓名/手机号搜索" style="width:100%">
            <el-option v-for="c in mentorOptions" :key="c.coachid" :label="c.coachname + '（ID:' + c.coachid + '）'" :value="c.coachid" />
          </el-select>
        </el-form-item>
        <el-form-item label="徒弟">
          <el-select v-model="pairForm.apprenticeId" filterable remote reserve-keyword :remote-method="searchApprentice" :loading="coachLoading" placeholder="输入姓名/手机号搜索" style="width:100%">
            <el-option v-for="c in apprenticeOptions" :key="c.coachid" :label="c.coachname + '（ID:' + c.coachid + '）'" :value="c.coachid" />
          </el-select>
        </el-form-item>
        <el-form-item label="周期开始">
          <el-date-picker v-model="pairForm.pairPeriodStart" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width:100%" />
        </el-form-item>
        <el-form-item label="周期结束">
          <el-date-picker v-model="pairForm.pairPeriodEnd" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width:100%" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="pairVisible = false">取消</el-button>
        <el-button type="primary" :loading="pairing" @click="doPair">保存</el-button>
      </template>
    </el-dialog>

    <!-- 批量导入（P0） -->
    <el-dialog v-model="importVisible" title="批量导入结对" width="620px">
      <el-alert type="info" :closable="false" show-icon
        title="每行一条：导师coachId,徒弟coachId,周期开始,周期结束，逗号分隔；商学院整体结对，支持跨校区跨城市" />
      <el-input v-model="importText" type="textarea" :rows="8" style="margin-top:12px"
        placeholder="示例：
1001,2001,2026-01-01,2026-12-31
1002,2002,2026-01-01,2026-12-31" />
      <div v-if="importResult" style="margin-top:12px">
        <el-alert :type="importResult.failCount ? 'warning' : 'success'" :closable="false" show-icon
          :title="'成功 ' + importResult.successCount + ' 条，失败 ' + importResult.failCount + ' 条'" />
        <el-table v-if="importResult.failed && importResult.failed.length" :data="importResult.failed" border size="small" style="margin-top:8px">
          <el-table-column prop="index" label="行号" width="60" />
          <el-table-column prop="reason" label="失败原因" />
        </el-table>
      </div>
      <template #footer>
        <el-button @click="importVisible = false; importResult = null">关闭</el-button>
        <el-button type="primary" :loading="importing" @click="doImport">开始导入</el-button>
      </template>
    </el-dialog>

    <!-- 培养进度总览 -->
    <el-dialog v-model="progressVisible" :title="progressTitle" width="680px">
      <div v-loading="progressLoading" style="min-height:120px">
        <template v-if="progress">
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="导师">{{ progress.mentorName }}</el-descriptions-item>
            <el-descriptions-item label="徒弟">{{ progress.apprenticeName }}</el-descriptions-item>
            <el-descriptions-item label="期 / 阶段">{{ periodStageText({ relation: progress.relation, period: periodFromPair(progress.relation.pairDate), stageMonth: monthsFromPair(progress.relation.pairDate) }) }}</el-descriptions-item>
            <el-descriptions-item label="状态">{{ statusText(progress.relation.status) }}</el-descriptions-item>
            <el-descriptions-item label="结对周期">{{ progress.relation.pairPeriodStart }} ~ {{ progress.relation.pairPeriodEnd }}</el-descriptions-item>
            <el-descriptions-item label="完成度">
              <el-progress :percentage="progress.progressPercent" :stroke-width="14" />
            </el-descriptions-item>
          </el-descriptions>
          <el-table :data="progress.performanceList" border size="small" style="margin-top:12px">
            <el-table-column label="日期" width="150">
              <template #default="scope">{{ scope.row.year}}年{{ scope.row.month}}月</template>
            </el-table-column>
            <el-table-column prop="target" label="业绩目标" />
            <el-table-column prop="accomplish" label="完成情况" />
          </el-table>
          <el-table :data="progressRows" border size="small" style="margin-top:12px">
            <el-table-column prop="name" label="环节" width="150" />
            <el-table-column prop="status" label="完成情况" />
          </el-table>
          <el-descriptions v-if="progress.taskReceived" :column="2" border size="small" style="margin-top:12px">
            <el-descriptions-item label="任务接收">{{ progress.taskReceived }} 个</el-descriptions-item>
            <el-descriptions-item label="任务提交">{{ progress.taskSubmitted }} 个</el-descriptions-item>
          </el-descriptions>
          <el-alert v-if="progress.radar" type="info" :closable="false" show-icon style="margin-top:12px"
            :title="'最新健康度：' + healthText(progress.radar.healthType) + '（学习' + progress.radar.learningScore + ' / 影响' + progress.radar.influenceScore + ' / 乐趣' + progress.radar.funScore + ' / 回报' + progress.radar.rewardScore + '）'" />
          <div v-if="timeline" style="margin-top:16px">
            <div class="tl-head">
              <span class="tl-title">帮带时间轴</span>
              <span class="tl-stat">完成 {{ timeline.doneCount }}/{{ timeline.totalCount }}
                <el-tag v-if="timeline.overdueCount" type="danger" size="small">逾期 {{ timeline.overdueCount }}</el-tag>
              </span>
            </div>
            <el-timeline style="margin-top:12px; padding-left:6px">
              <el-timeline-item v-for="n in timeline.nodes" :key="n.key" :type="timelineType(n)"
                :hollow="!n.done" :timestamp="n.time ? fmtTime(n.time) : (n.status === 2 ? '已逾期' : '')">
                <div class="tl-node">
                  <span class="tl-node-title" :class="{ done: n.done, overdue: n.status === 2 }">{{ n.title }}</span>
                  <span v-if="n.statusText" class="tl-node-tag">{{ n.statusText }}</span>
                  <span v-if="n.key === 'track' && n.trackDate" class="tl-node-tag">最近 {{ n.trackDate }}</span>
                  <span v-if="n.key === 'assessment' && n.grade" class="tl-node-tag">等级 {{ n.grade }}</span>
                  <span v-if="n.key === 'radar' && n.totalScore != null" class="tl-node-tag">总分 {{ n.totalScore }}</span>
                  <div class="tl-node-desc">{{ n.desc }}</div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mentorAdminRelations, mentorAdminUnpair, mentorAdminDeleteRelation, mentorAdminImportPairs, mentorSearchCoach, mentorAdminProgress, mentorTimeline } from '@/api/mentor'
import { ElMessage, ElMessageBox } from 'element-plus'

const PERIOD_OPTIONS = [2026, 2027, 2028, 2029, 2030]

export default {
  name: 'MentorRelationManage',
  data () {
    return {
      loading: false,
      total: 0,
      tableData: [],
      operatorId: Number(localStorage.getItem('sysUserId') || localStorage.getItem('userId') || 1),
      query: { page: 1, size: 10, status: null, keyword: '', period: null, radar: null, dateRange: null },
      periodOptions: PERIOD_OPTIONS,
      // 新建结对
      pairVisible: false, pairing: false, coachLoading: false,
      mentorOptions: [], apprenticeOptions: [],
      pairForm: { mentorId: null, apprenticeId: null, pairPeriodStart: '', pairPeriodEnd: '' },
      // 批量导入
      importVisible: false, importing: false, importText: '', importResult: null,
      // 培养进度
      progressVisible: false, progressLoading: false, progressTitle: '', progress: null, timeline: null
    }
  },
  computed: {
    progressRows () {
      const p = this.progress
      if (!p) return []
      const tools = p.tools || {}
      const row = (name, done, extra) => ({ name, status: done ? extra : '未完成' })
      const rows = []
      rows.push(row('工具一·职业兴趣', tools.tool1, this.toolStatusText(tools.tool1 && tools.tool1.status)))
      rows.push(row('工具二·性格适配', tools.tool2, this.toolStatusText(tools.tool2 && tools.tool2.status)))
      rows.push(row('工具三·价值观职业锚', tools.tool3, this.toolStatusText(tools.tool3 && tools.tool3.status)))
      rows.push(row('工具四·能力地图', tools.tool4, this.toolStatusText(tools.tool4 && tools.tool4.status)))
      rows.push(row('工具五·四大黄金问题', tools.tool5, this.toolStatusText(tools.tool5 && tools.tool5.status)))
      rows.push(row('表1·目标设定', p.goalSettingDone, '已完成'))
      rows.push(row('表2·月度追踪', p.trackCount > 0, p.trackCount + ' 次'))
      rows.push(row('表3·综合考核', p.assessmentDone, '已完成'))
      return rows
    }
  },
  mounted () { this.load() },
  methods: {
    async load () {
      this.loading = true
      const params = { page: this.query.page, size: this.query.size }
      if (this.query.status != null) params.status = this.query.status
      if (this.query.keyword) params.keyword = this.query.keyword
      if (this.query.period != null) params.period = this.query.period
      if (this.query.radar != null) params.radar = this.query.radar
      if (this.query.dateRange && this.query.dateRange.length === 2) {
        params.createStart = this.query.dateRange[0]
        params.createEnd = this.query.dateRange[1]
      }
      const r = await mentorAdminRelations(params)
      this.loading = false
      if (r && r.code === 200) {
        // 后端已返回 period / stageMonth / hasRadar，并已按 radar 过滤 + 分页
        this.tableData = r.data.records || []
        this.total = r.data.total || 0
      } else {
        this.tableData = []
        this.total = 0
        ElMessage.warning((r && r.message) || '查询失败')
      }
    },
    search () { this.query.page = 1; this.load() },
    reset () { this.query.status = null; this.query.keyword = ''; this.query.period = null; this.query.radar = null; this.query.dateRange = null; this.query.page = 1; this.load() },
    onPage (p) { this.query.page = p; this.load() },
    onSize (s) { this.query.size = s; this.query.page = 1; this.load() },
    // 期 / 阶段展示（后端已算 period / stageMonth；兜底用结对时间算）
    periodStageText (row) {
      const period = row.period || this.periodFromPair(row.relation && row.relation.pairDate)
      const stage = row.stageMonth || this.monthsFromPair(row.relation && row.relation.pairDate)
      if (!period) return this.stageLabel(stage)
      return period + '期·' + this.stageLabel(stage)
    },
    stageLabel (s) { if (!s || s <= 0) return '-'; if (s > 12) return '已满期(' + s + '个月)'; return '第' + s + '个月' },
    periodFromPair (d) { if (!d) return null; return new Date(d).getFullYear() },
    monthsFromPair (d) { if (!d) return 0; const p = new Date(d); const n = new Date(); return Math.max((n.getFullYear() - p.getFullYear()) * 12 + (n.getMonth() - p.getMonth()) + 1, 1) },
    statusText (s) { return ['', '已结对', '进行中', '已完成', '已解绑'][s] || s },
    statusTag (s) { return ['', 'success', 'primary', 'info', 'danger'][s] || '' },
    goRadar (row) {
      const q = 'relationId=' + row.relation.id +
        '&mentorName=' + encodeURIComponent(row.mentorName || '') +
        '&apprenticeName=' + encodeURIComponent(row.apprenticeName || '') +
        '&periodStage=' + encodeURIComponent(this.periodStageText(row))
      this.$router.push('/mentorRadar?' + q)
    },
    healthText (t) { return ['', '全面健康', '结构性失衡', '全面预警'][t] || '-' },
    toolStatusText (s) { return s === 2 ? '已复核' : '已提交待复核' },
    async showProgress (relationId) {
      this.progressVisible = true; this.progressLoading = true; this.progress = null; this.timeline = null
      const [pr, tl] = await Promise.all([ mentorAdminProgress({ relationId }), mentorTimeline({ relationId }) ])
      this.progressLoading = false
      if (pr && pr.code === 200) { this.progress = pr.data; this.progressTitle = '培养进度 · ' + pr.data.mentorName + ' 带 ' + pr.data.apprenticeName }
      else ElMessage.warning((pr && pr.message) || '加载失败')
      if (tl && tl.code === 200) this.timeline = tl.data
    },
    timelineType (n) { if (n.status === 2) return 'danger'; return n.done ? 'success' : 'info' },
    fmtTime (t) { if (!t) return ''; return String(t).replace('T', ' ').substring(0, 16) },
    // 删除关系（真删除：逻辑删 is_delete=1，列表不再显示）
    doDelete (relationId) {
      ElMessageBox.confirm('确认删除该师徒关系？删除后不再显示（区别于解绑，解绑保留记录）。', '确认删除', { type: 'warning' })
        .then(() => mentorAdminDeleteRelation({ relationId }))
        .then(r => { if (r && r.code === 200) { ElMessage.success('已删除'); this.load() } else ElMessage.warning((r && r.message) || '操作失败') })
        .catch(() => {})
    },
    doUnpair (relationId) {
      ElMessageBox.prompt('解绑原因', '确认解绑', { inputType: 'textarea' })
        .then(({ value }) => mentorAdminUnpair({ relationId, reason: value || '' }))
        .then(r => { if (r && r.code === 200) { ElMessage.success('已解绑'); this.load() } else ElMessage.warning((r && r.message) || '操作失败') })
        .catch(() => {})
    },
    async searchMentor (kw) { this.mentorOptions = await this.searchCoach(kw) },
    async searchApprentice (kw) { this.apprenticeOptions = await this.searchCoach(kw) },
    async searchCoach (kw) {
      if (!kw) return []
      this.coachLoading = true
      const r = await mentorSearchCoach({ name: kw })
      this.coachLoading = false
      if (r && r.code === 200 && r.data) return Array.isArray(r.data) ? r.data : (r.data.records || [])
      return []
    },
    async doPair () {
      const f = this.pairForm
      if (!f.mentorId || !f.apprenticeId || !f.pairPeriodStart || !f.pairPeriodEnd) { ElMessage.warning('请选择导师/徒弟并填写完整周期'); return }
      this.pairing = true
      const rows = [{ mentorId: f.mentorId, apprenticeId: f.apprenticeId, pairPeriodStart: f.pairPeriodStart, pairPeriodEnd: f.pairPeriodEnd, areaId: 0 }]
      const r = await mentorAdminImportPairs(rows)
      this.pairing = false
      if (r && r.code === 200) {
        if (r.data.failCount) ElMessage.warning('结对失败：' + (r.data.failed[0] ? r.data.failed[0].reason : ''))
        else { ElMessage.success('结对成功'); this.pairVisible = false; this.pairForm = { mentorId: null, apprenticeId: null, pairPeriodStart: '', pairPeriodEnd: '' }; this.load() }
      } else ElMessage.warning((r && r.message) || '操作失败')
    },
    parseImportRows () {
      const rows = []
      const lines = this.importText.split(/\r?\n/).map(s => s.trim()).filter(Boolean)
      for (const line of lines) {
        const parts = line.split(/[,，]/).map(s => s.trim())
        if (parts.length < 4) continue
        rows.push({ mentorId: parts[0], apprenticeId: parts[1], pairPeriodStart: parts[2], pairPeriodEnd: parts[3], areaId: 0 })
      }
      return rows
    },
    async doImport () {
      const rows = this.parseImportRows()
      if (!rows.length) { ElMessage.warning('未解析到有效数据行'); return }
      this.importing = true
      const r = await mentorAdminImportPairs(rows)
      this.importing = false
      if (r && r.code === 200) { this.importResult = r.data; if (!r.data.failCount) ElMessage.success('批量结对成功 ' + r.data.successCount + ' 条'); this.load() }
      else ElMessage.warning((r && r.message) || '导入失败')
    }
  }
}
</script>

<style scoped>
:deep(.el-card) { border-radius: 12px; box-shadow: 0 2px 8px rgba(31, 45, 61, .08); }
:deep(.el-card__header) { font-weight: 600; background: #fafbfc; border-radius: 12px 12px 0 0; }
:deep(.el-button) { border-radius: 6px; }
.tl-head { display: flex; align-items: center; justify-content: space-between; padding: 8px 10px; background: #f7f8fa; border-radius: 8px; }
.tl-title { font-weight: 600; font-size: 14px; }
.tl-stat { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #606266; }
.tl-node { line-height: 1.5; }
.tl-node-title { font-weight: 600; font-size: 14px; color: #303133; }
.tl-node-title.done { color: #67c23a; }
.tl-node-title.overdue { color: #f56c6c; }
.tl-node-tag { display: inline-block; margin-left: 8px; padding: 0 8px; border-radius: 10px; background: #ecf5ff; color: #409eff; font-size: 12px; line-height: 20px; vertical-align: 1px; }
.tl-node-desc { color: #909399; font-size: 12px; margin-top: 2px; }
</style>
